/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import styles from './index.less';
import AnimationItem from './animationItem/index';
import InsertIndicator from './insertIndicator';
import Dropdown from '@com-pc/dropdown';
import i18n from '@i18next/i18n';
import { ANIMATION_EDITOR_REF_ID } from './constants';
import classNames from 'classnames';
import { ADD_ANIMATION_ICON, ANIM_PLAY_ICON } from './images';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IAnimationEditorProps, IAnimationEditorService, IAnimationEditorState } from '@src/slide/application/service/animation-editor-manager/core/interface';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import AnimationEditorModel from '@src/slide/application/service/animation-editor-manager/core/model';
import AnimHistoryGallery from './animationHistoryGallery';
import Close from '@com/animation-editor/images/close.svg';

export default class AnimationEditor extends Component<IAnimationEditorProps, IAnimationEditorState> {
    private animationEditorService: IAnimationEditorService;
    // refs
    private scrollContainer: HTMLElement|null;
    private editorBottom: HTMLElement|null;
    private dropdown;

    public constructor(props) {
        super(props);
        props.getAnimationEditorService().setViewDelegate(new class extends ReactView<IAnimationEditorProps> {
            public getElementById(id: string) {
                return (this.realView as AnimationEditor)?.getRefById(id);
            }
        }(this));
        this.animationEditorService = props.getAnimationEditorService();
    }

    public componentDidMount() {
        this.animationEditorService?.componentDidMount();
    }

    public componentWillUnmount() {
        this.animationEditorService?.componentWillUnmount();
    }

    public componentDidUpdate() {
        this.animationEditorService?.componentDidUpdate();
    }

    public render() {
        if (!this.animationEditorService) {
            return <></>;
        }
        const { animList, hasAnimSupportElement } = this.getState();
        const disableAddBtn = !hasAnimSupportElement;
        const animListLength = animList.map(i => i.data.length).reduce((pre, cur) => pre += cur, 0);
        this.animationEditorService?.setAnimListLength(animListLength);
        const addBtnClass = classNames({
            [styles['add-animation-btn-disabled']]: disableAddBtn,
            [styles['add-animation-btn']]: true,
        });
        this.animationEditorService?.filterBlindsAnimationFor3DModels();
        return (
            <div className={`${styles.editor}`}
                style={{
                    display: 'flex',
                }}
                onContextMenu={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <div className={styles['editor-animation-header']}>
                    <div className={styles['editor-animation-header-title']} >{i18n.t('动画')}</div>
                    <img className={styles['editor-animation-header-close-button']} src={Close} onClick={() => this.animationEditorService?.close()}/>
                </div>
                {
                    animListLength
                        ? <React.Fragment>
                            <div
                                ref={(ref) => {
                                    this.scrollContainer = ref;
                                }}
                                className={`${styles['editor-content']} menu-scroll`}
                                style={(browser.isSafari || browser.isIE) ? { paddingRight: 16 } : {}}
                            >
                                { this.renderAnimQueues() }
                            </div>
                        </React.Fragment>
                        : null
                }
                <div className={classNames({
                    [styles['editor-bottom']]: true,
                    [styles['editor-bottom-padding-top']]: animListLength === 0,
                })}
                ref={(ref) => {
                    this.editorBottom = ref;
                }}
                >
                    {
                        disableAddBtn
                            ? <React.Fragment>
                                <div className={addBtnClass}>
                                    <img src={ADD_ANIMATION_ICON} style={{ width: 16, height: 16 }}></img>
                                    <span className={styles.tips}>{i18n.t('请选择需添加动画的对象')}</span>
                                </div>
                            </React.Fragment>
                            :  <React.Fragment>
                                <div className={addBtnClass} id='addAnimationBtn'>
                                    <img src={ADD_ANIMATION_ICON} style={{ width: 16, height: 16 }}></img>
                                    <span className={styles.tips}>{i18n.t('添加动画')}</span>
                                </div>
                                <Dropdown
                                    ref={(ref) => {
                                        this.dropdown = ref;
                                    }}
                                    style={{
                                        overflow: 'unset',
                                        maxHeight: '404px',
                                        borderRadius: '4px',
                                        boxSizing: 'border-box',
                                        boxShadow: `0 6px 32px 2px rgba(0, 0, 0, 0.16),
                                                    0 4px 6px 2px rgba(0, 0, 0, 0.04),
                                                    0 0 0 1px rgba(0, 0, 0, 0.04)`,
                                        backdropFilter: 'blur(8px)',
                                        overflowY: 'scroll',
                                    }}
                                    belongID={'addAnimationBtn'}
                                    hasShadow={false}
                                    autoAlign={true}
                                    offsetX={-1}
                                    aligment="right"
                                    dropContent={
                                        <AnimHistoryGallery onSelect={this.animationEditorService?.addAnimation} />
                                    }></Dropdown>
                            </React.Fragment>
                    }
                </div>
            </div>
        );
    }

    public getRefById(id: string) {
        switch (id) {
            case ANIMATION_EDITOR_REF_ID.SCROLL_CONTAINER:
                return this.scrollContainer;
            case ANIMATION_EDITOR_REF_ID.EDITOR_BOTTOM:
                return this.editorBottom;
            case ANIMATION_EDITOR_REF_ID.DROP_DOWN:
                return this.dropdown;
        }
    }

    private getState() {
        return this.animationEditorService?.getModel() as AnimationEditorModel;
    }

    private renderMainAnimHeader = () => (<div className={styles['animation-queue-header']}>
        <div className={styles['animation-queue-header-title']}>{i18n.t('主动画')}</div>
        <div className={styles['animation-queue-header-play']}>
            <img className={styles['animation-header-playIcon']} src={ANIM_PLAY_ICON} onClick={this.animationEditorService?.previewAllAnimation}/>
            <div className={styles['animation-header-playTitle']} onClick={this.animationEditorService?.previewAllAnimation}>{i18n.t('播放全部')}</div>
        </div>
    </div>);

    private renderTriggerAnimHeader = (queue, triggerIndex, hasMainSeq) => <div className={classNames(styles['animation-queue-header'], styles['animation-queue-header-title'], {
        [styles['animation-queue-header-trigger']]: hasMainSeq,
    })}>
        <div>{`${i18n.t('触发动画')}${triggerIndex}`}</div>
        <Tooltip title={queue.title} overlayHoverable={false} style={{ height: 24 }}>
            <span className={styles['animation-queue-header-clipable']}>{queue.title}</span>
        </Tooltip>
    </div>;


    private renderAnimQueues() {
        if (!this.animationEditorService) {
            return;
        }
        const { getAnimQueues, isDragHover, clearDragPosition, saveDragPositionChange } = this.animationEditorService;
        const animQueues = getAnimQueues(this.getState().animList);
        if (!animQueues) {
            return;
        }
        let triggerIndex = 0;
        let hasMainSeq = false;
        return animQueues
            .map((queue, queueIndex) => {
                if (queue.isMainSeq) {
                    hasMainSeq = true;
                } else {
                    triggerIndex += 1;
                }
                return (<React.Fragment key={queueIndex}>
                    { queue.isMainSeq ? this.renderMainAnimHeader()
                        : this.renderTriggerAnimHeader(queue, triggerIndex, hasMainSeq) }
                    {
                        <div className={styles.indicatorInnerContainer}>
                            <InsertIndicator
                                isDragHover={isDragHover(null, queueIndex)}
                                onClearDragPosition={() => clearDragPosition()}
                                onDragPositionChange={() => saveDragPositionChange(null, queueIndex)}
                                canEdit={queue.canEdit}
                            />
                        </div>
                    }
                    {
                        queue.data?.map((group, groupIndex) => this.renderAnimGroups(
                            group,
                            groupIndex,
                            queue,
                            queueIndex,
                        ))
                    }
                </React.Fragment>
                );
            });
    }

    private renderAnimGroups(group, groupIndex, queue, queueIndex) {
        if (!this.animationEditorService) {
            return;
        }
        const {
            selectAnimation,
            handleVisibleChange,
            playAnimation,
            deleteAnimation,
            modifyAnimation,
            moveAnimation,
            calcAnimItemSty,
            getTriggerSelectOptions,
            calcIISty,
            isDragHover,
            clearDragPosition,
            saveDragPositionChange,
        } = this.animationEditorService;
        return group
            .map((animModel, animModelIndex) => {
                const aiProps = {
                    isShown: animModel.key === this.getState().unfoldItemKey,
                    canEdit: queue.canEdit,
                    onSelected: e => selectAnimation(e, animModel, queueIndex),
                    onVisibleChange: visible => handleVisibleChange(animModel, visible),
                    onPlay: () => playAnimation(animModel),
                    onDelete: () => deleteAnimation(animModel),
                    onModify: param => modifyAnimation(animModel, param, queueIndex),
                    onMove: () => moveAnimation(animModel),
                };
                if (!queue.canEdit) {
                    Object.keys(aiProps).forEach(k => (aiProps[k] = typeof aiProps[k] === 'boolean' ? false : () => {}));
                }
                return (
                    <React.Fragment key={animModel.key}>
                        <AnimationItem
                            key={`AnimationItem${animModel.key}`}
                            style={calcAnimItemSty(
                                queue,
                                group,
                                groupIndex,
                                animModelIndex,
                            )}
                            data={animModel}
                            isGroupFirstItem={animModelIndex === 0}
                            triggerSelectOptions={getTriggerSelectOptions()}
                            selectionService={this.animationEditorService?.getSelectionService()}
                            {...aiProps}
                        />
                        {
                            <InsertIndicator
                                style={calcIISty(group, animModelIndex)}
                                isDragHover={isDragHover(animModel, queueIndex)}
                                onClearDragPosition={() => clearDragPosition()}
                                onDragPositionChange={() => saveDragPositionChange(animModel, queueIndex)}
                                canEdit={queue.canEdit}
                            />
                        }
                    </React.Fragment>
                );
            });
    }
}
